import React, { Component } from 'react';
import {Card, CardActions, CardMedia, CardText} from 'material-ui/Card';
import TextField from 'material-ui/TextField'
import FlatButton from 'material-ui/FlatButton'
import Paper from 'material-ui/Paper'
import {red500 } from 'material-ui/styles/colors';
import { FormattedMessage, intlShape } from 'react-intl';

const localeMessages = {
  mailaddress: {
    id: "Supporter.LoginDialog.MailAddress",
    defaultMessage: "Email-Adresse"
  },
  password: {
    id: "Supporter.LoginDialog.Password",
    defaultMessage: "Passwort"
  },
  logintitle: {
    id: "Supporter.LoginDialog.LoginTitle",
    defaultMessage: "Login"
  }
}
class LoginDialog extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  state = {
    password: '',
    username: localStorage ? localStorage.getItem('username') : ''
  }

  submit(e) {
    e.preventDefault();
    this.props.onLogin(this.state.username, this.state.password);

    if (localStorage) {
      localStorage.setItem('username', this.state.username);
      localStorage.removeItem('language_changed');
    }
    this.setState({password: ''});
  }

  render() {
    const langChanged = (localStorage && localStorage.getItem('language_changed'));

    return (
      <div className="login" style={{margin: 'auto', textAlign: 'center', zIndex: 11}}>
        <img src={"Logo_" + this.props.locale + ".svg"} alt="" style={{
          maxWidth: '460px',
          marginBottom:'30px'
          }} />
        <Paper zDepth={1}>
          <Card style={{backgroundColor: 'white'}}>
            <CardMedia>
            </CardMedia>
            <form action="" ref="form" method="" onSubmit={(e) => this.submit(e)}>
              <CardText>
                {langChanged && 
                  <p style={{color: '#009a3c'}}>
                    <FormattedMessage
                      id="Supporter.LoginDialog.LanguageChanged"
                      defaultMessage="Sie benutzen Nextcare nun in Deutsch. Bitte loggen Sie sich erneut ein."
                    />
                  </p>}
                {this.props.authfail &&
                  <p style={{color: red500}}>
                    <FormattedMessage
                      id="Supporter.LoginDialog.LoginFailed"
                      defaultMessage="Login fehlgeschlagen"
                    />
                  </p>}
                {this.props.loggedout &&
                  <p style={{color: red500}}>
                    <FormattedMessage
                      id="Supporter.LoginDialog.LoggedOut"
                      defaultMessage="Sie wurden ausgeloggt"
                    />
                  </p>}
                <div>
                  <TextField
                    onInput={(e) => this.setState({username: e.target.value})}
                    value={this.state.username}
                    floatingLabelText={this.context.intl.formatMessage(localeMessages.mailaddress)}
                    floatingLabelFixed={true}
                    style={{width:'100%'}}
                  /><br/>
                  <TextField
                    floatingLabelText={this.context.intl.formatMessage(localeMessages.password)}
                    type="password"
                    floatingLabelFixed={true}
                    onInput={(e) => this.setState({password: e.target.value})}
                    value={this.state.password}
                    style={{width:'100%'}}
                  />
                  <button type="submit" style={{display:'none'}}>
                    <FormattedMessage
                      id="Supporter.LoginDialog.LoginTitle"
                      defaultMessage="Login"
                    />
                  </button>
                </div>
              </CardText>
              <CardActions>
                <FlatButton
                  label={this.context.intl.formatMessage(localeMessages.logintitle)}
                  primary={true}
                  onClick={(e) => this.submit(e)}
                />
              </CardActions>
            </form>
          </Card>
        </Paper>
      </div>
    )
  }
};

export default LoginDialog;


// WEBPACK FOOTER //
// ./src/LoginDialog.js